module.exports = __webpack_public_path__ + "static/img/recruit_title_logo_wide.ae6ac61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/recruit_title_logo_wide.png
// module id = EA4P
// module chunks = 0